<template>
      <v-card
        class="mx-auto"
        max-width="1000"
        min-width="300"
      >
        <v-toolbar class="pencil"   :color="ToolColor" dark @click="Loadin();Hide = !Hide">
          <v-toolbar-title>{{ Headline }}</v-toolbar-title>

          <v-toolbar-side-icon color="white darken-1">
            <v-icon v-if="Hide == false" color="orange ligthen-1" >arrow_downward</v-icon>
            <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
          </v-toolbar-side-icon>

          <v-spacer></v-spacer>
        </v-toolbar>
        
  <v-expand-transition>
        <div v-if="Hide">
          <More :color="choice.color" v-model="choiceShow" :feeling="choice.feeling" :name="choice.name"    :title="choice.title"/>

  <NewFeeling :schoolId="schoolId" :id="id"  v-model="dialogClass"   :membernameandId="membernameandId" />
          <div v-if="feelings.length!=0">
  <NewFeeling :schoolId="schoolId" :id="id"  v-model="dialog" :Oldclass="Class"  :membernameandId="membernameandId" />
  <div>
    <v-flex justify="center">
            <RemoveWindow   Type="feeling" :removeItem="removeItem" v-model="dialogDelete"   Headline="Ta bort Måendekoll " WarningText="Är du säker på att du vill ta bort denna måendekoll från EHTKollen? En måendekoll som är
              borttagen går inte att återfå."    />

    </v-flex>
                <v-text-field
          v-model="search"
          label="Sök efter elev"
          class="mx-4"
        ></v-text-field>


    <v-data-table
      :headers="headers"
      :items="feelings"
      item-key="name"
      sort-by="name"
      class="elevation-1"
      :pagination.sync="pagination"
      :search="search"
      show-group-by
    >
      <template v-slot:items="props">
        <td class="text-xs-right">{{ props.item.name }}</td>
        <td class="text-xs-right">
           <v-btn dark large  color="green ligthen-1" >
                {{ props.item.code }}
          </v-btn>
     </td>
        <td class="text-xs-right">
      <template v-for="feeling,i in props.item.feelings" >
                   <v-tooltip bottom :key="feeling.date+i">
      <template v-slot:activator="{ on }">
       <v-btn  v-on="on"
            class="mx-2"
            fab
            dark
            small
            color="purple ligthen-1"
          >
          {{feeling.feeling}}
          </v-btn>
 </template>
      <span>
        
     {{   locfun.getDate(
              feeling.date
            )}}
       </span>
    </v-tooltip>
</template>
          </td>

        <td class="text-xs-right">
      <template v-for="q,i in props.item.questions" >
                   <v-tooltip bottom :key="i">
      <template v-slot:activator="{ on }">
       <v-btn  v-on="on"
            class="mx-2"
            fab
            dark
            small
            @click="choice= choicelist[i];choice.feeling = props.item.feelings;choice.name =props.item.name;choiceShow=true;"
            :color="questions.find(quest=> quest.short==q).color"
          >
              <v-icon dark>  {{questions.find(quest=> quest.short==q).icon}} </v-icon>
    

          </v-btn>
 </template>
      <span>
        
          {{questions.find(quest=> quest.short==q).Q}}

       </span>
    </v-tooltip>
</template>
          </td>

        <td class="text-xs-right">{{ props.item.hasOwnProperty('expireDate')? props.item.expireDate: "Inget slutdatum" }}</td>



               <td class="text-xs-right" >
  <v-btn
            class="mx-2"
            fab
            dark
            small
            @click="
              removeItem = props.item;
              dialogInfo = true;
            "
            color="blue ligthen-1"
          >
            <v-icon dark> menu_book </v-icon>
          </v-btn>
        </td>
        <td class="text-xs-right">
          <v-btn
            class="mx-2"
            fab
            dark
            small
            @click="
              Class=props.item;dialog = true;
            "
            color="green ligthen-1"
          >
            <v-icon dark> upgrade </v-icon>
          </v-btn>
        </td>
        <td class="text-xs-right" >
  <v-btn
            class="mx-2"
            fab
            dark
            small
            @click="
              removeItem = props.item;
              dialogDelete = true;
            "
            color="red ligthen-1"
          >
            <v-icon dark> clear </v-icon>
          </v-btn>
        </td>

      </template>
            <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
         Det finns inget resultat för din sökning på "{{ search }}". 
        </v-alert>
      </template>
    </v-data-table>
         <div class="text-xs-center pt-2">
      <v-btn color="light-blue darken-1" dark @click="toggleOrder">Ändra sorteringsordning</v-btn>
      <v-btn color="light-blue darken-1" dark @click="nextSort">Sortera på nästa kolumn</v-btn>
    </div>
                 <v-btn 
      class="mx-2"
      dark
      @click="dialogClass=true"
      color="green darken-1"
    >
      Lägg till en måendekoll
    </v-btn>
  </div>
        </div>
              <div v-else  class="bellowPen" :class="ToolColor+ ' lighten-3 text-center'">  
    <span class="tt" color="white">Det finns ännu inga elever.</span>
    <v-btn 
      class="mx-2"
      dark
      @click="dialogClass=true"
      color="green darken-1"
    >
      Lägg till en måendekoll
    </v-btn>
    </div>
        </div>
  </v-expand-transition>
      </v-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import fun from "../functions";
import NewFeeling from "./NewFeeling.vue";
import RemoveWindow from "../assets/RemoveWindow";
import More from './More.vue';
export default {
  name: "Feeling",
  components: {
    NewFeeling,RemoveWindow,More
  },
  props: {
    // content: Array,
    Headline: String,
    ToolColor: String,
    schoolId: String,
    role: String,
    id: String,
    
  },

  watch: {
  },
  created() {
    this.locfun = new fun();
  },
  computed: {
    ...mapGetters("ehtmembers", ["membernameandId"]),
    ...mapGetters('feeling', ['feelings','feelingsFetched']),
  },
  methods: {
    ...mapActions('feeling', ['initFeelings']),

    Loadin()
    {
    if (this.feelingsFetched==false) {
      //console.log("Fetched");   
         this.initFeelings(this.schoolId)
}  
    },
    toggleOrder () {
        this.pagination.descending = !this.pagination.descending
      },
      nextSort () {
        let index = this.headers.findIndex(h => h.value === this.pagination.sortBy)
        index = (index + 1) % this.headers.length
        index = index === 0 ? index + 1 : index
        this.pagination.sortBy = this.headers[index].value
      },


    ...mapActions("classesAP", ["removeAP",'saveAP']),
    ...mapActions(["showSuccessSnackbar"]),
  },
  data() {
    return {
      
      search: '',
            pagination: {
          sortBy: 'steps[0].starttime'
        },
      removeItem: { name: "temp", id: "temp" },
      accessItem: { name: "temp", id: "temp" },
      choice:{ color:"blue", title:"test"},
      choicelist: [{ color:"red", title:"Medicin"}, { color:"blue", title:"Närvaro"}, { color:"green", title:"Mat"}, { color:"yellow", title:"Sömn"}],
      choiceShow: false, 
      dialogInfo: false,
      dialogDelete: false,
      dialogAccess: false,
      dis: {},
      dialog: false,
      dialogClass: false,
      Class: null,
      Choosen: null,
      Hide: false,
      questions:[{Q:"Har du tagit dina mediciner?", short:"med", ans:"y", icon: "medical_services" , color:"red"}
      ,{Q:"Har du varit eller ska du till skolan idag?", short:"sch", ans:"y", icon:"school" , color:"blue"}
      ,{Q:"Har du ätit mat i skolan idag?", short:"food", ans:"y", icon: "fastfood", color:"green"},
        {Q:"Hur många timmar har du sovit i natt?", short:"sleep", ans:"ten", icon: "hotel" , color:"orange"}],
          
      headers: [
        {
          text: "Namn",
          align: "start",
          value: "name"
        },
        { text: "Kod", value: "code", align: "right" },
        { text: "Mående", value: "link", align: "right" },
        { text: "Extra frågor", value: "link", align: "right" },
        { text: "Slutdatum", value: "createDate", align: "right" },
        { text: "Detalj", value: "createDate", align: "right" },
        { text: "Ändra", value: "createDate", align: "right" },
        { text: "Ta bort", value: "tabort", align: "right" },
      ],
    };
  },
};
</script>